(function () {
  var FADE_OUT_MS = 250;
  var isNavigating = false;

  // ─── Helpers ────────────────────────────────────────────────

  function getMain() {
    return document.getElementById('MainContent');
  }

  function isInternalLink(link) {
    try {
      var url = new URL(link.href);
      if (url.origin !== location.origin) return false;
      if (link.target === '_blank') return false;
      var href = link.getAttribute('href') || '';
      if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
      // Shopify checkout and account/login flows must do a real navigation
      if (url.pathname.startsWith('/checkout') || url.pathname.startsWith('/account') || url.pathname.startsWith('/login')) return false;
      // Same page — ignore
      if (url.pathname === location.pathname && url.search === location.search) return false;
      return true;
    } catch (e) { return false; }
  }

  // Re-execute inline <script> tags injected via innerHTML (they don't run automatically)
  function rerunScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      Array.from(old.attributes).forEach(function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // ─── Reveal (scroll-driven) ──────────────────────────────────

  function setupReveal(el) {
    var children = Array.prototype.slice.call(el.children);
    if (!children.length) return;

    var viewportH = window.innerHeight;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pt-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.04 });

    children.forEach(function (child, i) {
      child.classList.add('pt-reveal');
      var rect = child.getBoundingClientRect();

      if (rect.top < viewportH) {
        // Above fold — all fade in together, no stagger
        child.style.transitionDelay = '0ms';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            child.classList.add('pt-visible');
          });
        });
      } else {
        // Below fold — reveal on scroll
        observer.observe(child);
      }
    });
  }

  // ─── AJAX navigation ────────────────────────────────────────

  function closeAllModals() {
    // Close mobile nav
    var nav = document.getElementById('mobileNav');
    if (nav) nav.classList.remove('open');
    // Close cart modal and release body scroll lock (skip scroll restore — AJAX nav scrolls to top)
    if (typeof closeCartModal === 'function') closeCartModal(true);
    document.body.classList.remove('modal-open', 'cart-open', 'search-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
  }

  function navigate(href, isPopState) {
    if (isNavigating) return;
    isNavigating = true;

    closeAllModals();

    var main = getMain();

    // Start fetch and fade-out simultaneously
    var fetchPromise = fetch(href)
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.text();
      });

    var fadePromise = new Promise(function (resolve) {
      if (main) {
        main.style.transition = 'opacity ' + FADE_OUT_MS + 'ms ease';
        main.style.opacity = '0';
        setTimeout(resolve, FADE_OUT_MS);
      } else {
        resolve();
      }
    });

    Promise.all([fetchPromise, fadePromise])
      .then(function (results) {
        var html = results[0];
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(html, 'text/html');
        var newMain = newDoc.getElementById('MainContent');

        if (!newMain) throw new Error('No MainContent in response');

        // Swap content
        var current = getMain();
        if (current) {
          current.innerHTML = newMain.innerHTML;
          current.className = newMain.className;
          // Start hidden so reveal can animate in
          current.style.transition = 'none';
          current.style.opacity = '0';
        }

        // Update title + URL
        document.title = newDoc.title;
        if (!isPopState) {
          history.pushState({ path: href }, newDoc.title, href);
        }

        // Scroll to top
        window.scrollTo(0, 0);

        // Re-run inline scripts (product form, section JS, etc.)
        if (current) rerunScripts(current);

        // Reveal new content — reset container opacity first so children can show through
        if (current) {
          current.style.transition = 'none';
          current.style.opacity = '1';
          setupReveal(current);
        }

        // Sync data-template and data-template-suffix so CSS page-specific rules update correctly
        var newTemplate = newDoc.documentElement.getAttribute('data-template');
        if (newTemplate !== null) {
          document.documentElement.setAttribute('data-template', newTemplate);
        }
        var newSuffix = newDoc.documentElement.getAttribute('data-template-suffix');
        document.documentElement.setAttribute('data-template-suffix', newSuffix || '');

        // Strip stale header state classes left by page-specific JS
        var headerEl = document.querySelector('.header');
        if (headerEl) {
          headerEl.classList.remove('header--light', 'header--dark-bg', 'header--hover');
          var desktopGrid = headerEl.querySelector('.header__grid--desktop');
          if (desktopGrid) desktopGrid.classList.remove('hovered');
        }

        // Re-run header theme detection after the new content has painted
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (typeof window._detectHeaderTheme === 'function') {
              window._detectHeaderTheme();
            }
          });
        });

        isNavigating = false;
      })
      .catch(function () {
        // Graceful fallback to normal navigation
        location.href = href;
      });
  }

  // ─── Intercept clicks ───────────────────────────────────────

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link || !isInternalLink(link)) return;
    e.preventDefault();
    navigate(link.href, false);
  });

  // ─── Back / Forward ─────────────────────────────────────────

  window.addEventListener('popstate', function () {
    navigate(location.href, true);
  });

  // ─── Initial page load ──────────────────────────────────────

  function waitForLCP(cb) {
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      cb();
    }

    var hard = setTimeout(fire, 2500);

    if ('PerformanceObserver' in window) {
      var settle;
      try {
        var po = new PerformanceObserver(function () {
          clearTimeout(settle);
          settle = setTimeout(fire, 150);
        });
        po.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch (e) {}
    }

    var heroImg = document.querySelector(
      '#MainContent img[fetchpriority="high"], #MainContent img[loading="eager"]'
    );
    if (heroImg) {
      if (heroImg.complete) {
        clearTimeout(hard);
        setTimeout(fire, 50);
      } else {
        heroImg.addEventListener('load',  function () { clearTimeout(hard); setTimeout(fire, 50); }, { once: true });
        heroImg.addEventListener('error', fire, { once: true });
      }
    }

    if (document.readyState === 'complete') {
      clearTimeout(hard);
      fire();
    } else {
      window.addEventListener('load', function () {
        clearTimeout(hard);
        setTimeout(fire, 50);
      }, { once: true });
    }
  }

  function revealPage() {
    var main = getMain();
    if (!main) return;
    document.documentElement.classList.remove('pt-loading');
    setupReveal(main);
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitForLCP(revealPage);
  });

})();
